import PropTypes from 'prop-types';
import { ButtonRounded } from '../../../UISystem/Buttons';

/**
 * AnonThreadGate — what fills the composer slot while THREAD is locked
 * (variants block plan 3, Step 5; design `anon_3_shared-info.png`).
 *
 * THREAD's gate is HARD, not the soft morph CHAT ships: the composer is not
 * present in a locked form, it is absent, and this stands in its place. That
 * is the variant's entire premise — you land in the thread so the connection
 * is visibly real, and there is exactly ONE thing to do. The share gate IS the
 * instruction, which is how this answers the old chat landing's two confusions
 * ("are we already connected?" / "what do I do?") with a single move.
 *
 * D6 — this renders IMMEDIATELY, before the host has shared anything. The mock
 * couples the CTA to the host's card row, but nothing requires it: a slow host
 * would otherwise leave a screen with nothing to do, which is the exact
 * failure this variant exists to fix. The Anon may go first.
 *
 * D7 — "Share contact", not "Share back". Once the CTA can precede the host's
 * share, "back" presupposes a reciprocity that hasn't happened. "Share
 * contact" is true in both orders.
 *
 * D10 — "Remind me later" retires on tap and never returns for this room. The
 * caller owns that state (per-room localStorage, not session state): a return
 * through the calendar link days later means the reminder did its job.
 *
 * Both controls are stock UISystem — the white pill is `secondary`, the quiet
 * text link is `blank`, which is the treatment the design system already
 * showcases for this exact string.
 */
const AnonThreadGate = ({ onShare, onRemindLater, showRemindLater }) => (
  <div
    style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '18px',
      paddingTop: '2px',
      paddingBottom: '10px',
    }}
  >
    <ButtonRounded
      text="Share contact"
      onClick={onShare}
      variant="secondary"
      size="auto"
      style={{ minWidth: '210px' }}
    />

    {showRemindLater && (
      <ButtonRounded text="Remind me later" onClick={onRemindLater} variant="blank" size="inline" />
    )}
  </div>
);

AnonThreadGate.propTypes = {
  onShare: PropTypes.func.isRequired,
  onRemindLater: PropTypes.func,
  showRemindLater: PropTypes.bool,
};

export default AnonThreadGate;
